import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { Language } from '../entities/language';

/**
 * Base url
 */
const BASE_URL = 'languages';

/**
 * Language service
 */
@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  /**
   * Constructor
   *
   * @param apiService ApiService
   */
  constructor(private apiService: ApiService) {}

  /**
   * List
   *
   * @returns Observable with languages
   */
  list(): Observable<Language[]> {
    return this.apiService.get(BASE_URL).pipe(map((languages) => languages.map((language) => Language.createFromJson(language))));
  }
}
